interface ShortCodeResponse {
  code: string;
}

interface ShortCodeStatusResponse {
  subscriptions: {
    adobe: string;
    paramountPlus: string;
  };
  refreshToken: string;
}

export const parseShortCode = (response: ShortCodeResponse) => {
  return response.code;
};

export const parseShortCodeStatus = (response: ShortCodeStatusResponse) => {
  return {
    subscriptionStatus: {
      adobe: getStatusFromCode(response.subscriptions.adobe),
      paramountPlus: getStatusFromCode(response.subscriptions.paramountPlus),
    },
    refreshToken: response.refreshToken,
  };
};

export const Status = {
  SUCCESS: 'success',
  PENDING: 'pending',
  FAILED: 'failed',
};

const getStatusFromCode = (code: string): string => {
  switch (code) {
    case 'p':
      return Status.PENDING;
    case 'y':
      return Status.SUCCESS;
    case 'n':
    default:
      return Status.FAILED;
  }
};
